import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sends a GA4 `page_view` event on every route change.
 * Needed because React Router changes the URL without a full page reload,
 * and gtag('config') only fires once on initial load.
 *
 * Must be rendered inside <BrowserRouter>.
 */
export default function RouteTracker() {
    const location = useLocation();

    useEffect(() => {
        if (typeof window === "undefined" || typeof window.gtag !== "function") return;
        // Send explicit page_view event with the current SPA path
        window.gtag("event", "page_view", {
            page_path: location.pathname.startsWith("/parceiros") ? location.pathname : location.pathname + location.search,
            page_location: location.pathname.startsWith("/parceiros") ? window.location.origin + location.pathname : window.location.href,
            page_title: document.title,
        });
    }, [location.pathname, location.search]);

    return null;
}
